@if (isFilterShown) {
  <div>
    <h1>{{this.fieldLabels['title']}}</h1>
    <!--<a class="usa-link"
    (click)="rowClick(null)">{{this.fieldLabels['latest']}}
    &nbsp;
    <button class="usa-button  usa-button--active" disabled>
      {{count}}
    </button>
  </a>-->
  <efast-filter-plan-year [events]="events" ></efast-filter-plan-year>
  <efast-filter-defined-benefit [events]="events" ></efast-filter-defined-benefit>
  <efast-filter-defined-contribution [events]="events"> </efast-filter-defined-contribution>
  <efast-filter-other-pension [events]="events"> </efast-filter-other-pension>
  <efast-filter-welfare [events]="events"></efast-filter-welfare>
  <efast-filter-assets [events]="events"></efast-filter-assets>
  <efast-filter-participants [events]="events"></efast-filter-participants>
  <efast-filter-employer [events]="events"></efast-filter-employer>
  <efast-filter-business [events]="events"></efast-filter-business>
  <efast-filter-states [events]="events"></efast-filter-states>
  <efast-filter-foreign [events]="events"></efast-filter-foreign>
  <efast-filter-zipcode [events]="events"></efast-filter-zipcode>
  <efast-filter-form-year [events]="events"></efast-filter-form-year>
</div>
}<!-- CLOSE .info-banner -->